import api from './api';

export const getSummerSportsRegistrations = async () => {
    return api.get('/api/summer-sports/registrations');
};

export const createSummerSportsRegistration = async (payload) => {
    return api.post('/api/summer-sports/registrations', payload);
};

export const downloadSummerSportsExcel = async () => {
    return api.get('/api/summer-sports/export-excel', {
        responseType: 'blob'
    });
};

